export enum BP_LAYERS {
  RED_LAYER='red_layer',
  BLUE_LAYER='blue_layer',
  GREEN_LAYER='green_layer',
  YELLOW_LAYER='yellow_layer'
}

export const layers: string[] = ['red_layer', 'blue_layer', 'green_layer', 'yellow_layer'];